// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs__tabs--2On","tab":"Tabs__tab--1CU","active":"Tabs__active--17c"};